import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';

export type FormValueType = {
  name: string;
  tables?: string[];
  epics?: string[];
};
export const useSchemaSheet = (projectData: ProjectDto, initialValue: FormValueType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const existingSheets = projectData.sheets
    .map((sheet) => sheet.name?.toLocaleLowerCase())
    .filter((sheet) => sheet !== initialValue?.name?.toLocaleLowerCase());

  return useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingSheets, t('addSheets.existing'))
          .max(250),
        tables: Yup.array().min(1).required(),
        epics: Yup.array().min(1).required(),
      }),
    [t, existingSheets],
  );
};
